import axios from "axios";

export const makeRequest = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
  },
});
